import React from "react";
import {Badge, Tabs, Tooltip} from "antd";
import IWidgetProps from "../../../../model/interface/widget/IWidgetProps";
import IWidget from "../../../../model/interface/widget/IWidget";
import Widget from "./Widget";
import IWidgetPropsFunctions from "../../../../model/interface/widget/IWidgetPropsFunctions";
import ITabsOptions from "../../../../model/interface/widget/option/ITabsOptions";
import LocaleText from "../../settings/dictionary/LocaleText";
import FieldsService from "../../../../model/service/dataStorage/FieldsService";
import ICardWidgetPropsFunctions from "../../../../model/interface/dataStorage/card/ICardWidgetPropsFunctions";

interface IState {
    activeTab?: string
    closed: boolean
    seenChangedFields: string[]
}

class TabsWidget extends React.Component<IWidgetProps<IWidgetPropsFunctions<IWidget<ITabsOptions>>, ITabsOptions>, IState>  {

    constructor(props: IWidgetProps<IWidgetPropsFunctions<IWidget<ITabsOptions>>, ITabsOptions>) {
        super(props);
        this.state = {
            activeTab: undefined,
            closed: this.props.options.closed || false,
            seenChangedFields: []
        }
    }

    componentDidMount() {
        const {id, functions} = this.props
        const activeTab = window.localStorage.getItem('tabs/' + id)
        if(activeTab) {
            this.setState(_state => ({activeTab}))
            this.triggerChangeSeen(activeTab)
        } else {
            const children = functions.getSortedChildren(id)
            this.triggerChangeSeen(children[0]?.id + "")
        }
    }

    onChange(activeTab: string) {

        try {
            window.localStorage.setItem('tabs/' + this.props.id, activeTab)
        } catch(e) {
            console.error('Unable to write to local storage', e)
        }
        this.triggerChangeSeen(activeTab);

        this.setState({activeTab, closed: false})
    }

    private triggerChangeSeen(activeTab: string) {
        const {id, functions, resource} = this.props
        const children = functions.getSortedChildren(id)
        const chosen = children.find(c => c.id === activeTab)
        if (resource && chosen && this.hasFieldsContentBeenChanged(chosen) && 'getContentType' in functions) {
            const contentType = (functions as ICardWidgetPropsFunctions).getContentType()
            this.getContentChangedFields(chosen).forEach((name) => {
                const field = contentType.fields.find(f => f.name === name)
                if (field?.id && resource.id) {
                    FieldsService.seenChangeLog(field.id, resource.id)
                    this.setState(state => ({seenChangedFields: [...state.seenChangedFields, field.name]}))
                }
            })

        }
    }

    render() {
        const { id, functions, options } = this.props
        const {activeTab, closed} = this.state
        const tabPosition = ((options && options.tabPosition) || 'top')
        const children = functions.getSortedChildren(id)

        return (
            <>
                {children.length > 0 && (
                    <Tabs tabPosition={tabPosition} activeKey={closed ? 'dummy_value' : (activeTab || children[0].id + "")} onChange={(key: string) => this.onChange(key)}>
                        {children.map((child) => {
                            return (
                                <Tabs.TabPane key={child.id + ""} tab={(
                                    <>
                                        {child.options ? (
                                                this.hasFieldsContentBeenChanged(child) && activeTab !== child.id ?
                                                    <Tooltip title={<LocaleText code={'configuration.widget.tab.alert-chang-fields-tooltip'} fallback={'Nový obsah'}/>}>
                                                        <Badge color={'red'} offset={[10, 0]}>
                                                            <LocaleText code={child.options.label}/>
                                                        </Badge>
                                                    </Tooltip>
                                                    :
                                                    <LocaleText code={child.options.label}/>
                                        ) : (
                                            <>
                                                Tab { child.id }
                                            </>
                                        )}
                                    </>
                                )}>
                                    {!closed && (
                                        <Widget
                                            {...this.props}
                                            {...child}
                                            id={child.id}
                                            key={child.id}
                                        />
                                    )}
                                </Tabs.TabPane>
                            )
                        })}
                    </Tabs>
                )}
            </>
        );
    }

    hasFieldsContentBeenChanged(child: IWidget){
        const {resource} = this.props
        const {seenChangedFields} = this.state
        return child.options.alertChangeFields?.some((f: string) => resource?._unseenChangedFields?.includes(f) && !seenChangedFields.includes(f))
    }

    getContentChangedFields(child: IWidget): string[]{
        const {resource} = this.props
        console.log(child.options.alertChangeFields?.some((f: string) => resource?._unseenChangedFields?.includes(f)))
        return child.options.alertChangeFields?.filter((f: string) => resource?._unseenChangedFields?.includes(f))
    }
}

export default TabsWidget